import React, { useEffect, useState } from 'react';
import apiService from '../services/apiService';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';

const VenueCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ name: '', description: '' });
  const [saving, setSaving] = useState(false);
  const [detailsCategory, setDetailsCategory] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await apiService.getVenueCategories();
      setCategories(res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const openCreate = () => {
    setEditingId(null);
    setForm({ name: '', description: '' });
    setFormOpen(true);
  };

  const openEdit = (cat) => {
    setEditingId(cat.id);
    setForm({ name: cat.name, description: cat.description || '' });
    setFormOpen(true);
  };

  const save = async () => {
    if (!form.name.trim()) return alert('Il nome è obbligatorio');
    try {
      setSaving(true);
      if (editingId) {
        await apiService.updateVenueCategory(editingId, form);
      } else {
        await apiService.createVenueCategory(form);
      }
      setFormOpen(false);
      await load();
    } catch (err) {
      alert(err.response?.data?.error || err.message);
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Eliminare questa categoria?')) return;
    try {
      await apiService.deleteVenueCategory(id);
      await load();
    } catch (err) {
      alert(err.response?.data?.error || err.message);
    }
  };

  const openDetails = (category) => {
    setDetailsCategory(category);
  };

  const closeDetails = () => {
    setDetailsCategory(null);
  };

  return (
    <div>
      <div className="card">
        <h2>🏷️ Categorie Venue</h2>
        <p>Catalogo globale di categorie usate per raggruppare le venue e applicare config remote per scope. Le associazioni si modificano entrando nel singolo locale.</p>
        <button className="btn btn-primary" onClick={openCreate} style={{ marginTop: 12 }}>
          + Nuova Categoria
        </button>
      </div>

      {error && <div className="card" style={{ color: 'red' }}>❌ {error}</div>}

      {formOpen && (
        <div className="card">
          <h3>{editingId ? 'Modifica Categoria' : 'Nuova Categoria'}</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 400 }}>
            <label>
              Nome *
              <input
                className="form-input"
                value={form.name}
                onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                placeholder="es. Ristorante"
              />
            </label>
            <label>
              Descrizione
              <input
                className="form-input"
                value={form.description}
                onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
                placeholder="Descrizione opzionale"
              />
            </label>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" onClick={save} disabled={saving}>
                {saving ? 'Salvataggio...' : 'Salva'}
              </button>
              <button className="btn" onClick={() => setFormOpen(false)}>Annulla</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        {loading ? (
          <p>Caricamento...</p>
        ) : categories.length === 0 ? (
          <p>Nessuna categoria presente.</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '8px 4px', borderBottom: '1px solid #eee' }}>Nome</th>
                <th style={{ textAlign: 'left', padding: '8px 4px', borderBottom: '1px solid #eee' }}>Slug</th>
                <th style={{ textAlign: 'left', padding: '8px 4px', borderBottom: '1px solid #eee' }}>Descrizione</th>
                <th style={{ textAlign: 'left', padding: '8px 4px', borderBottom: '1px solid #eee' }}>Venue associate</th>
                <th style={{ textAlign: 'left', padding: '8px 4px', borderBottom: '1px solid #eee' }}>Locali associati</th>
                <th style={{ padding: '8px 4px', borderBottom: '1px solid #eee' }}></th>
              </tr>
            </thead>
            <tbody>
              {categories.map(cat => (
                <tr key={cat.id}>
                  <td style={{ padding: '8px 4px' }}>{cat.name}</td>
                  <td style={{ padding: '8px 4px', color: '#888', fontSize: 13 }}>{cat.slug}</td>
                  <td style={{ padding: '8px 4px', color: '#666' }}>{cat.description || '—'}</td>
                  <td style={{ padding: '8px 4px' }}>
                    <span style={{ background: '#eef2ff', color: '#3730a3', padding: '3px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600 }}>
                      {cat.venueCount || 0}
                    </span>
                  </td>
                  <td style={{ padding: '8px 4px' }}>
                    <button
                      className="btn icon-btn"
                      title="Vedi locali associati"
                      onClick={() => openDetails(cat)}
                    >
                      <VisibilityIcon fontSize="small" />
                    </button>
                  </td>
                  <td style={{ padding: '8px 4px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button className="btn icon-btn" title="Modifica" onClick={() => openEdit(cat)}><EditIcon fontSize="small" /></button>
                    <button className="btn btn-danger icon-btn" title="Elimina" onClick={() => remove(cat.id)}><DeleteIcon fontSize="small" sx={{ color: 'white' }} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {detailsCategory && (
        <div className="modal-overlay" onClick={closeDetails}>
          <div className="modal" style={{ maxWidth: '760px', width: '100%' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <h3 style={{ margin: 0 }}>Locali associati a {detailsCategory.name}</h3>
                <p style={{ margin: '6px 0 0', color: '#64748b', fontSize: 14 }}>
                  Consulta qui l&apos;elenco dei locali che usano questa categoria. Per cambiare l&apos;associazione entra nei dettagli del singolo locale e modifica la categoria da lì.
                </p>
              </div>
              <button className="modal-close" onClick={closeDetails}>×</button>
            </div>

            <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                <span style={{ background: '#eef2ff', color: '#3730a3', padding: '4px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600 }}>
                  {detailsCategory.venueCount || 0} {(detailsCategory.venueCount || 0) === 1 ? 'locale associato' : 'locali associati'}
                </span>
                <span style={{ color: '#64748b', fontSize: 13 }}>
                  La categoria qui e&apos; solo consultabile.
                </span>
              </div>

              {detailsCategory.venues?.length ? (
                <div style={{ maxHeight: '420px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 10, paddingRight: 4 }}>
                  {detailsCategory.venues.map((venue) => (
                    <div key={venue.id} style={{ border: '1px solid #e2e8f0', borderRadius: 12, padding: '12px 14px', background: '#fff' }}>
                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                        <strong style={{ color: '#0f172a' }}>{venue.name}</strong>
                        {venue.tenant?.company_name && (
                          <span style={{ background: '#ecfeff', color: '#0f766e', borderRadius: 999, padding: '2px 8px', fontSize: 11, fontWeight: 600 }}>
                            {venue.tenant.company_name}
                          </span>
                        )}
                        <span style={{ background: '#eef2ff', color: '#3730a3', borderRadius: 999, padding: '2px 8px', fontSize: 11, fontWeight: 600 }}>
                          {venue.activeDeviceCount} device
                        </span>
                      </div>
                      <div style={{ marginTop: 6, fontSize: 12, color: '#64748b' }}>
                        {venue.address || 'Indirizzo non disponibile'}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ fontSize: 14, color: '#64748b' }}>
                  Nessun locale associato a questa categoria.
                </div>
              )}

              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button className="btn" onClick={closeDetails}>Chiudi</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default VenueCategories;
